import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../component/Toasts/Toasts";
import * as actions from "../../Redux/Actions/index";
import { Dropdown, Form } from "react-bootstrap";
import ModalComponents from "../../component/ModalComponent/ModalComponent";
import ModalWarning from "../../component/MakerChecker/ModalWarning";
import ReasonForRejection from "../../component/MakerChecker/ReasonForRejection";
import {
  experienceValidation,
  jobTitleValidation,
  referralAmountValidation,
  workLevelValidation,
} from "../../constant/Validations";
import {
  SkillLinksValidationStrings,
  Strings,
  jobCategoryDropdown,
  modeOfWorkDropdown,
  workLevelDropdown,
  workLevelArray,
  workExperienceObj,
  referalAmountObj,
  employementType,
} from "../../constant/Strings";
import { stripHtml } from "./HtmlToText";
import Select from "react-select";
import { AiOutlineCheck } from "react-icons/ai";

const EditPostAJob = (props: any) => {
  const {
    jobsData,
    hideEditReferResource,
    apiCallCompleted,
    buHeadDropdown,
  } = props;
  const [category, setCategory] = useState([]);
  const jobId = jobsData._id;
  const role = localStorage.getItem("role");
  const [btnDisable, setBtnDisable] = useState(false);
  const [approvedButtonDisbale, setApprovedButtonDisbale] = useState(false);
  const [buHeadDetails, setBuheadDetails] = useState({
    buHeadEmail: "",
    buHeadid: "",
    buHeadName: "",
  });
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const isCheckedData = role && role.includes("skill-link-checker");
  const [jobs, setJobs] = useState<any>({
    jobTitle: jobsData.jobTitle,
    jobCategory: jobsData.jobCategory,
    modeOfWork: jobsData.modeOfWork,
    experience: jobsData.experience,
    location: jobsData.location,
    workLevel: jobsData.workLevel,
    // referralAmount: jobsData.referralAmount,
    description: jobsData.description,
    uploadJobDescription: jobsData.uploadJobDescription,
    recordStatus: "Updated",
    majorSkills: jobsData.majorSkills,
    salaryRange: jobsData?.salaryRange,
    employmentType: jobsData?.employmentType,
    customerName: jobsData.customerName,
  });
  const isFeildDisbled = jobsData?.isQuestlightPosted == 1 ? true : false;
  const [jobCoOrdinatorOptions, setJobCoOrdinatorOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const {
    job_title,
    job_category,
    work_level,
    BUHeadLabel,
    recruitersLabel,
    upload_description,
    description,
    major_skills,
    cancel,
    save,
    discard,
    submit,
    upload,
    imageSize2mb,
    approve,
    reject,
    experience,
    location_label,
    referral_amount,
    mode_of_work,
    sr_associate,
    lead,
    manager,
    sr_manager,
    avp,
    vp,
    sr_vp,
    file_size_max_msg,
    file_type_msg,
    editSuccess,
    majorSkills_valid,
    ctc_range,
    employment_type,
  } = Strings;
  const {
    exp_4_10_years,
    exp_7_11_years,
    exp_8_15_years,
    exp_10_20_years,
    exp_12_20_years,
    exp_15_20_years,
    exp_15_30_years,
  } = workExperienceObj;
  const {
    jobTitle_error,
    jobCategory_error,
    modeOfWork_error,
    experience_error,
    workLevel_error,
    referralAmount_error,
    ctc_range_error,
    ctc_greater_error,
  } = SkillLinksValidationStrings;
  const { referral5000, referral15000, referral25000 } = referalAmountObj;
  const dispatch = useDispatch();
  const addJobCategory = useSelector(
    (state: any) => state.employeeReducer.addJobCategoryDetails
  );
  const [locationOption, setLocationOption] = useState([]);
  const [lacationValue, setLocationValue] = useState("");

  const getWorkLocationApi = () => {
    dispatch(
      actions.GetWorkLocationAction((res: any) => {
        if (res?.error?.error_description) {
          showErrorToastMessage(res.error.error_description);
        } else if (res?.code === 200) {
          setLocationOption(res.data);
        }
      })
    );
  };

  const handleOtherLocation = () => {
    const payload = {
      status: 1,
      workLocationName: lacationValue,
    };
    dispatch(
      actions.addWorkLocationAction(payload, (res: any) => {
        if (res?.error?.error_description) {
          setLocationValue("");
          showErrorToastMessage(res.error.error_description);
        } else if (res?.code === 200) {
          showSuccessToastMessage(Strings.addSuccess);
          setLocationValue("");
          getWorkLocationApi(); 
        }
      })
    );
  };

  useEffect(() => {
    getWorkLocationApi(); 
  }, []);
  useEffect(() => {
    dispatch(actions.getJobCategoryAction());
  }, [addJobCategory]);

  const getJobCategory = useSelector(
    (state: any) => state.employeeReducer.getJobCategoryDetails
  );

  useEffect(() => {


    if (jobsData && buHeadDropdown?.length > 0) {

      // --- NEW DATA PATH ---
      // If the job has the rich 'buheadDetails' object, it is the source of truth.
      if (jobsData.buheadDetails) {

        // Set the state to display the name/email/id from the job's own data.
        setBuheadDetails({
          buHeadEmail: jobsData.buheadDetails.email || "",
          buHeadid: jobsData.buheadDetails.id || "",
          buHeadName: jobsData.buheadDetails.name || "",
        });

        loadRecruiters(jobsData.buheadDetails.id);

        // --- OLD DATA PATH ---
        // If it's old data, we must search the dropdown list to find the details.
      } else if (jobsData.buhead) {
        let foundBuHead = null;
        const matchString = (jobsData.buhead || '').trim().toLowerCase();

        if (matchString) {
          foundBuHead = buHeadDropdown.find(
            (ele: any) =>
              (ele.name ?? '').trim().toLowerCase() === matchString ||
              (ele.email ?? '').trim().toLowerCase() === matchString
          );
        }

        if (foundBuHead) {
          setBuheadDetails({
            buHeadEmail: foundBuHead.email || "",
            buHeadid: foundBuHead.id || "",
            buHeadName: foundBuHead.name || "",
          });
          loadRecruiters(foundBuHead.id);
        } else {
          console.log("FAILURE: No match found for old data BU Head string.");
        }
      }
    }
  }, [jobsData, buHeadDropdown]);

  useEffect(() => {
    if (getJobCategory) {
      if (getJobCategory.data) {
        setCategory(getJobCategory.data);
      }
    }
  }, [getJobCategory, category]);

  useEffect(() => {
    if (
      jobs.jobTitle &&
      jobs.modeOfWork &&
      //jobs.jobCategory &&
      jobs.experience &&
      jobs.location &&
      //jobs.workLevel &&
      // jobs.referralAmount &&
      (jobs.description || jobs.uploadJobDescription) &&
      jobs.majorSkills?.length > 0 &&
      jobs?.salaryRange,
      jobs.customerName
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
    if (
      jobsData?.recordStatus == "Approved" ||
      jobsData?.recordStatus == "Rejected"
    ) {
      setApprovedButtonDisbale(false);
    } else {
      if (buHeadDetails?.buHeadEmail != "" && selectedOptions?.length > 0) {
        setApprovedButtonDisbale(false);
      } else {
        setApprovedButtonDisbale(true);
      }
    }
  }, [jobs, buHeadDetails, selectedOptions, jobsData]);
  useEffect(() => {
    dispatch(
      actions.getQuestCustomersAction((res: any) => {
        if (res.code === 200) {
          setCustomerOptions(res.data);
        }
        else {
          showErrorToastMessage(
            res?.error?.error_description || "Failed to load customer list. Please try again."
          );
        }
      })
    );
  }, []);

  const [errors, setErrors] = useState({
    jobTitle: "",
    jobCategory: "",
    modeOfWork: "",
    experience: "",
    location: "",
    workLevel: "",
    referralAmount: "",
    description: "",
    salaryRange: "",
    customerName: "",
    buhead: "",
    recruiters: "",
  });
  let valid: boolean = true;
  const validate = () => {
    if (jobTitleValidation(jobs.jobTitle) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        jobTitle: jobTitle_error,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        jobTitle: "",
      }));
    }
    if (jobTitleValidation(jobs.modeOfWork) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        modeOfWork: modeOfWork_error,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        modeOfWork: "",
      }));
    }
    if (experienceValidation(jobs.experience) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        experience: experience_error,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        experience: "",
      }));
    }
    if (jobs.location === "") {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        location: SkillLinksValidationStrings.location_error, 
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        location: "",
      }));
    }
    
    // if (referralAmountValidation(jobs.referralAmount) == false) {
    //   valid = false;
    //   setErrors((errorObj) => ({
    //     ...errorObj,
    //     referralAmount: referralAmount_error,
    //   }));
    //   setBtnDisable(false);
    // } else {
    //   setErrors((errorObj) => ({
    //     ...errorObj,
    //     referralAmount: "",
    //   }));
    // }
    if (jobs.salaryRange === "" || Number(jobs.salaryRange) < 1200000) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        salaryRange:
          jobs.salaryRange === "" ? ctc_range_error : ctc_greater_error,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        salaryRange: "",
      }));
    }
    if (!jobs.customerName) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        customerName: "Customer Name is required",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, customerName: "" }));
    }

    // For BU Head, we check the buHeadDetails state
    if (!buHeadDetails.buHeadEmail) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        buhead: "BU Head is required",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, buhead: "" }));
    }

    // For Recruiters, we check if any options have been selected
    if (selectedOptions.length === 0) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        recruiters: "Recruiters are required",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, recruiters: "" }));
    }
  };

  const handleWorkLevelChange = (eventKey: any) => {
    workLevelArray.forEach((element: any) => {
      if (element == eventKey) {
        if (eventKey == sr_associate) {
          setJobs({
            ...jobs,
            experience: exp_4_10_years,
            workLevel: eventKey,
            // referralAmount: referral5000,
          });
        }
        if (eventKey == lead) {
          setJobs({
            ...jobs,
            experience: exp_7_11_years,
            workLevel: eventKey,
            // referralAmount: referral15000,
          });
        }
        if (eventKey == manager) {
          setJobs({
            ...jobs,
            experience: exp_8_15_years,
            workLevel: eventKey,
            // referralAmount: referral15000,
          });
        }
        if (eventKey == sr_manager) {
          setJobs({
            ...jobs,
            experience: exp_10_20_years,
            workLevel: eventKey,
            // referralAmount: referral15000,
          });
        }
        if (eventKey == avp) {
          setJobs({
            ...jobs,
            experience: exp_12_20_years,
            workLevel: eventKey,
            // referralAmount: referral25000,
          });
        }
        if (eventKey == vp) {
          setJobs({
            ...jobs,
            experience: exp_15_20_years,
            workLevel: eventKey,
            // referralAmount: referral25000,
          });
        }
        if (eventKey == sr_vp) {
          setJobs({
            ...jobs,
            experience: exp_15_30_years,
            workLevel: eventKey,
            // referralAmount: referral25000,
          });
        }
      }
    });
  };
  const [showReason, setShowReason] = useState(false);
  const [showReasonForRejection, setShowReasonForRejection] = useState(false);
  const handleRejectModal = () => {
    setShowReasonForRejection(true);
  };
  const hideRejectModal = () => {
    setShowReasonForRejection(false);
  };
  const [modalWarning, setModalWarning] = useState("");
  const handleApproval = (text: any) => {
    setModalWarning(text);
    setShowReason(true);
  };
  const hideModal = () => {
    setShowReason(false);
  };

  const [docFile, setDocFile] = useState<any>({
    uploadJobDescription: null,
  });
  const handleJobDescriptionSubmit = (e: any) => {
    const file = e.target.files[0];
    const fileName = file.name;
    if ((fileName.match(/\./g) || []).length > 1) {
      showErrorToastMessage("Invalid filename. Double extensions are not allowed.");
      e.target.value = null;
      setLoading(true); 
      return;
    }
    const fileSize = file.size;
    const fileType = file.type;
    if (fileSize > 2 * 1024 * 1024) {
      showErrorToastMessage(file_size_max_msg);
      return;
    } else if (!["application/pdf"].includes(fileType)) {
      showErrorToastMessage(file_type_msg);
      return;
    } else {
      setDocFile({ ...docFile, uploadJobDescription: e.target.files[0] });
      dispatch(
        actions.jobDescriptionUploadAction(
          { file: e.target.files[0] },
          (res: any) => {
            if (res.code == 200 && res.data) {
              setJobs({
                ...jobs,
                uploadJobDescription: res.data,
              });
            }
          }
        )
      );
    }
  };

  const handleLocation = (eventKey: any) => {
    setJobs({
      ...jobs,
      location: eventKey,
    });
  };

  const handleEdit = () => {
    validate();
    if (valid) {
      handleDispatch();
      hideEditReferResource();
    }
  };
  const handleDispatch = () => {
    apiCallCompleted(false);
    const payload = {
      ...jobs, 
      buhead: buHeadDetails?.buHeadEmail || "", 
      recruiters: selectedOptions?.map((item: any) => item.email).join(";"), 
    };
    dispatch(
      actions.editSkilLinksJobStatusAction(jobId, payload, (res: any) => {
        if (res?.error?.error_description) {
          showErrorToastMessage(res.error.error_description);
          apiCallCompleted(true);
        } else if (res?.code === 200) {
          showSuccessToastMessage(editSuccess);
          apiCallCompleted(true);
        }
      })
    );
  };

  const loadRecruiters = (id: any) => {
    setLoading(true);
    dispatch(
      actions.getBUHeadsRecruitersAction(id, (res: any) => {
        const options = res.length > 0
          ? res.map((ele: any) => ({
            value: ele.id,
            label: ele.name,
            email: ele.email,
          }))
          : [];
        setJobCoOrdinatorOptions(options);

        if (jobsData.recruiterDetails && jobsData.recruiterDetails.length > 0) {

          const preSelectedRecruiters = jobsData.recruiterDetails.map((rec: any) => ({
            value: rec.id,
            label: rec.name,
            email: rec.email
          }));

          setSelectedOptions(preSelectedRecruiters);

          // --- OLD DATA PATH ---
        } else if (jobsData.recruiters) {
          const recruiterStrings = jobsData.recruiters.split(/[,;]/).map((item: any) => item.trim().toLowerCase());
          const preSelectedRecruiters = options.filter((opt: any) =>
            recruiterStrings.includes((opt.label ?? '').trim().toLowerCase()) ||
            recruiterStrings.includes((opt.email ?? '').trim().toLowerCase())
          );
          setSelectedOptions(preSelectedRecruiters);
        }

        setLoading(false);
      })
    );
  };

  const handleOptionChange = (option: any, isChecked: boolean) => {
    let updatedOptions: any;
    if (isChecked) {
      updatedOptions = [...selectedOptions, option];
    } else {
      updatedOptions = selectedOptions.filter(
        (o: any) => o?.value !== option?.value
      );
    }
    setSelectedOptions(updatedOptions);
  };

  return (
    <>
      <div>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">{job_title}</label>
            <span className="required">*</span>
            <input
              type="text"
              className="form-control"
              value={jobs?.jobTitle || ""}
              onChange={(e) =>
                setJobs({
                  ...jobs,
                  jobTitle: e.target.value,
                })
              }
            />
            <p className="error">{errors?.jobTitle}</p>
          </div>
          <div className="col-md-4">
            <label className="form-label">{employment_type}</label>
            <Dropdown
              onSelect={(eventKey: any) =>
                setJobs({
                  ...jobs,
                  employmentType: eventKey,
                })
              }
            >
              <Dropdown.Toggle variant="light" className="form-control">
                {jobs?.employmentType}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {employementType?.length > 0 &&
                  employementType.map((value: any) => (
                    <Dropdown.Item key={value} eventKey={value}>
                      {value}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-md-4">
            <label className="form-label">{mode_of_work}</label>
            <span className="required">*</span>
            <Dropdown
              onSelect={(eventKey: any) =>
                setJobs({
                  ...jobs,
                  modeOfWork: eventKey,
                })
              }
            >
              <Dropdown.Toggle
                variant="light"
                className="form-control"
                //disabled={isFeildDisbled}
              >
                {jobs?.modeOfWork}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {modeOfWorkDropdown?.length > 0 &&
                  modeOfWorkDropdown.map((value: any) => (
                    <Dropdown.Item eventKey={value}>{value}</Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-md-4">
            <label className="form-label">{job_category}</label>
            <Dropdown
              onSelect={(eventKey: any) =>
                setJobs({
                  ...jobs,
                  jobCategory: eventKey,
                })
              }
            >
              <Dropdown.Toggle variant="light" className="form-control">
                {jobs?.jobCategory}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {jobCategoryDropdown?.length > 0 &&
                  jobCategoryDropdown.map((value: any) => (
                    <Dropdown.Item eventKey={value}>{value}</Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-md-4">
            <label className="form-label">{location_label}</label>
            <span className="required">*</span>
            <Dropdown
              onSelect={(e) => {
                handleLocation(e);
              }}
            >
              <Dropdown.Toggle
                variant="light"
                className="form-control training-location-dropdown"
              >
                {jobs.location ? jobs.location : "Select Location"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu">
                <Form>
                  <Form.Group controlId="technolgyAdd">
                    <div className="input-group d-flex flex-row justify-content-between align-items-center">
                      <div className="otherInputform widthEightyFive">
                        <Form.Control
                          type="text"
                          placeholder="Enter Other"
                          value={lacationValue}
                          onChange={(e) => setLocationValue(e.target.value)}
                          id="technolgyAdd"
                        />
                      </div>
                      <div className="input-group-append">
                        <button
                          type="button"
                          className={
                            lacationValue.trim() !== ""
                              ? "btn btn-primary"
                              : "btn btn-disabled"
                          }
                          onClick={handleOtherLocation}
                        >
                          <AiOutlineCheck />
                        </button>
                      </div>
                    </div>
                  </Form.Group>
                </Form>
                {locationOption?.map((ele: any) => (
                  <Dropdown.Item key={ele.workLocationName} eventKey={ele.workLocationName}>
                    {ele.workLocationName}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <p className="error">
              {errors?.location} 
            </p>
          </div>

          <div className="col-md-4">
            <label className="form-label">{work_level}</label>
            <Dropdown
              onSelect={(eventKey: any) => {
                handleWorkLevelChange(eventKey);
              }}
            >
              <Dropdown.Toggle variant="light" className="form-control">
                {jobs?.workLevel}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {workLevelDropdown?.length > 0 &&
                  workLevelDropdown.map((value: any) => (
                    <Dropdown.Item eventKey={value}>{value}</Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-md-4">
            <label className="form-label">{experience}</label>
            <span className="required">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="5 to 10 years"
              value={jobs?.experience || ""}
              onChange={(e) =>
                setJobs({
                  ...jobs,
                  experience: e.target.value,
                })
              }
           //   disabled
            />
            <p className="error">{errors?.experience}</p>
          </div>
          {/* <div className="col-md-4">
            <label className="form-label">{referral_amount}</label>
            <span className="required">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Amount in Rupees"
              maxLength={5}
              value={jobs?.referralAmount || ""}
              onChange={(e) =>
                setJobs({
                  ...jobs,
                  referralAmount: e.target.value,
                })
              }
            />
            <p className="error">{errors?.referralAmount}</p>
          </div> */}
          <div className="col-md-4">
            <label className="form-label">{major_skills}</label>
            <span className="required">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Enter skills seperated with comma"
              value={jobs?.majorSkills || ""}
              onChange={(e) => {
                const skillArray = e.target.value
                  .split(",")
                  .map((skill: any) => skill);
                const updatedMajorSkills =
                  skillArray.length === 1 && skillArray[0] === ""
                    ? []
                    : skillArray;
                setJobs({
                  ...jobs,
                  majorSkills: updatedMajorSkills,
                });
              }}
            />
            {/* <p className="error">
              {jobs?.majorSkills?.length > 5 && majorSkills_valid}
            </p> */}
          </div>
          <div className="col-md-4">
            <label className="form-label">{ctc_range}</label>
            <span className="required">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="CTC Range"
              value={jobs?.salaryRange || ""}
             // disabled={isFeildDisbled}
              onChange={(e) =>
                setJobs({
                  ...jobs,
                  salaryRange: e.target.value,
                })
              }
            />
            <p className="error">{errors?.salaryRange}</p>
          </div>
          <div className="col-md-4">
            <label className="form-label">{BUHeadLabel}</label>
            <span className="required">*</span>
            <Dropdown
              onSelect={(eventKey: any) => {
                setLoading(true);
                setSelectedOptions([]);
                setJobCoOrdinatorOptions([]);
                const selectedValues: any =
                  buHeadDropdown?.length > 0 &&
                  buHeadDropdown.filter((ele: any) => {
                    return ele.id === eventKey;
                  })[0];
                setBuheadDetails((prev: any) => ({
                  ...prev,
                  buHeadName: selectedValues?.name ? selectedValues.name : "",
                  buHeadid: eventKey,
                  buHeadEmail: selectedValues?.email
                    ? selectedValues.email
                    : "",
                }));
                loadRecruiters(eventKey);
              }}
            >
              <Dropdown.Toggle
                variant="light"
                className="form-control"
                disabled={
                  jobsData?.recordStatus && jobsData?.recordStatus == "Approved"
                }
              >
                {buHeadDetails?.buHeadName}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {buHeadDropdown?.length > 0 &&
                  buHeadDropdown.map((value: any) => (
                    <Dropdown.Item eventKey={value.id}>
                      {value?.name}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="col-md-4">
            <label className="form-label">{recruitersLabel}</label>
            <span className="required">*</span>
            <Select
              options={jobCoOrdinatorOptions}
              isMulti
              isLoading={loading}
              isDisabled={
                jobsData.recordStatus && jobsData?.recordStatus == "Approved"
              }
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              value={selectedOptions}
              onChange={(selected: any) => {
                setSelectedOptions(selected);
              }}
              closeMenuOnSelect={false}
              components={{
                Option: (props: any) => (
                  <div className="custom-option buttonsize">
                    <div className="row">
                      <div className="col-8 mx-3 my-1">{props.label}</div>
                      <div className="col-1 my-2 buttonsize">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            handleOptionChange(props?.data, e.target?.checked);
                          }}
                          checked={
                            selectedOptions?.length > 0 &&
                            selectedOptions.some(
                              (selectedOption: any) =>
                                selectedOption.value === props.data.value
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                ),
              }}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Customer Name</label>
            <span className="required">*</span>
            <Dropdown
              onSelect={(eventKey: any) => {
                setJobs({ ...jobs, customerName: eventKey });
              }}
            >
              <Dropdown.Toggle variant="light" className="form-control">
                {jobs.customerName || "Select Customer"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu">
                {customerOptions.map((client: any) => (
                  <Dropdown.Item key={client.id} eventKey={client.client_name}>
                    {client.client_name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {!jobs.uploadJobDescription?.document_path_url && (
            <div className="col-md-8">
              <label className="form-label">{description}</label>
              <span className="required">*</span>
              <textarea
                className="form-control"
                placeholder="Please copy paste the entire JD including location experience, skillset required."
                value={
                  isFeildDisbled
                    ? stripHtml(jobs?.description)
                    : jobs?.description
                }
                onChange={(e) =>
                  setJobs({
                    ...jobs,
                    description: e.target.value,
                  })
                }
              />
            </div>
          )}
          {jobs.description == "" && (
            <div className="col-md-4">
              <label className="form-label">{upload_description}</label>
              <span className="required">*</span>
              <div>
                <input
                  type="file"
                  className="form-control"
                  value={jobs?.uploadJobDescription?.name || ""}
                  onChange={handleJobDescriptionSubmit}
                  hidden
                  id="actual-btn-uploadJob"
                />
                <label
                  htmlFor="actual-btn-uploadJob"
                  className="upload-jd-button upload-width"
                >
                  {upload}
                </label>
              </div>
              <p className="image-size-condition">
                {imageSize2mb}
                <span className="required">*</span>
              </p>
              <a
                href={jobs?.uploadJobDescription?.document_path_url}
                target="_blank"
                className="buttonsize"
              >
                {jobs?.uploadJobDescription?.document_path_url
                  ? "View File"
                  : ""}
              </a>
              <p className="image-size-condition">
                {docFile?.uploadJobDescription?.name}
              </p>
            </div>
          )}
        </div>
        <div className="row">
          {isCheckedData == false ? (
            <></>
          ) : jobsData?.recordStatus &&
            (jobsData?.recordStatus == "Approved" ||
              jobsData?.recordStatus == "Rejected") ? (
            <></>
          ) : (
            <>
              <div className="modal-btn-wrapper mt-2 mx-auto">
                <button
                  type="button"
                  className="btn btn-success buttonsize"
                  onClick={() => {
                    handleApproval("Approve");
                  }}
                  disabled={approvedButtonDisbale}
                >
                  {approve}
                </button>
                <button
                  type="button"
                  className="btn btn-danger buttonsize"
                  onClick={() => {
                    handleRejectModal();
                  }}
                >
                  {reject}
                </button>
              </div>
            </>
          )}
          <div className="modal-btn-wrapper mt-5 mx-auto">
            <div>
              <button
                className="btn cancel-btn buttonsize"
                onClick={hideEditReferResource}
              >
                {discard}
              </button>
            </div>
            <div>
              <button
                className={
                  btnDisable
                    ? "btn add-submit-button buttonsize"
                    : "btn add-submit-button btn-disabled buttonsize"
                }
                onClick={handleEdit}
              >
                {save}
              </button>
            </div>
          </div>
        </div>

        <ModalComponents
          show={showReason}
          onHide={hideModal}
          title=""
          modalBody={
            <ModalWarning
              apiCallCompleted={apiCallCompleted}
              hideModal={hideModal}
              header={modalWarning}
              id={jobId}
              editApi={actions.editSkilLinksJobStatusAction}
              data={{
                recordStatus: modalWarning + "d",
                buhead: buHeadDetails?.buHeadEmail || "",
                recruiters:
                  selectedOptions?.length > 0 &&
                  selectedOptions?.map((item: any) => item?.email).join(";"),
              }}
              hideEditModal={hideEditReferResource}
              setShowUndoPopup={() => {}}
            />
          }
          className="modal-md"
        />
        <ModalComponents
          show={showReasonForRejection}
          onHide={hideRejectModal}
          title="Reason For Rejection"
          modalBody={
            <ReasonForRejection
              apiCallCompleted={apiCallCompleted}
              hideModal={hideRejectModal}
              id={jobId}
              editApi={actions.editSkilLinksJobStatusAction}
              rejectData={{
                buhead: buHeadDetails?.buHeadEmail || "",
                recruiters:
                  selectedOptions?.length > 0 &&
                  selectedOptions?.map((item: any) => item?.email).join(";"),
              }}
              statusKey="recordStatus"
              hideEditModal={hideEditReferResource}
              setShowUndoPopup={() => {}}
            />
          }
          className="modal-md"
        />
      </div>
    </>
  );
};

export default EditPostAJob;
